<template>   
    <el-input placeholder="请输入内容" v-model=value :size="size">        
        <el-button slot="append" icon="el-icon-search" @click="onHanhleClick"></el-button>
    </el-input>   
</template>

<script>
export default {
    props:{
        size:String,
        value:String,
    },
    model:{
        prop:'value',
        event:'input'
    },
    watch:{
        value:function(newVal,oldVal){
            this.$emit('input',newVal)
        }
    },
    data(){
        return {
            status:false
        }
    },    
    methods:{
        onHanhleClick(){
            this.status=!this.status;
            this.$emit("onClick",this.status);
        }
    }
}
</script>